import gql from "graphql-tag";
import {client} from "./client";
import {RequestEntitiesByLayerType} from "../../schema/RequestEntitiesByLayerType";

/**
 *
 * TODO: use paging
 *
 * */

type result = {
    layerByType: {
        type: string;
        entitiesByLayerid: {
            nodes: Array<{
                fullUid: string;
            }>
        }
    }
}

export async function requestEntitiesByLayerType (type: string):
    Promise<Array<{fullUid: string}>> {
    try {
        const result: {data: result} = await client.query({
            fetchPolicy: 'network-only',
            query: gql`${RequestEntitiesByLayerType}`,
            variables: {
                type,
            }
        });
        console.log(result);
        return result.data.layerByType.entitiesByLayerid.nodes
            .filter(node => node);
    } catch (e) {
        return [];
    }
}
